/*
    Ideally this would be in a database somewhere but we didnt really have the time as it shares the database with FireMAP for it so here it is
*/

const mockMapConfig = {
    "layers": [{
        "key": "lyr_esri_light_gray",
        "xyz": {
            "maxZoom": 19,
            "minZoom": 3,
            "endpoints": [{
                "url": "https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}",
                "bbox": null,
                "zIndex": 10,
                "tokenKey": null,
                "layerDefs": null,
                "layersToShow": null
            }]
        },
        "name": "Light Gray",
        "legend": null,
        "opacity": 1,
        "identify": null
    }, {
        "key": "topo",
        "xyz": {
            "maxZoom": 19,
            "minZoom": 3,
            "endpoints": [{
                "url": "https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}",
                "bbox": null,
                "zIndex": 10,
                "tokenKey": null,
                "layerDefs": null,
                "layersToShow": null
            }]
        },
        "name": "Topographic",
        "legend": null,
        "opacity": 1,
        "identify": null
    }, {
        "key": "aerial",
        "xyz": {
            "maxZoom": 19,
            "minZoom": 3,
            "endpoints": [
                {
                    "url": "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                    "bbox": null,
                    "zIndex": 20,
                    "tokenKey": null,
                    "layerDefs": null,
                    "layersToShow": null
                }, {
                    "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}",
                    "bbox": null,
                    "zIndex": 40,
                    "tokenKey": null,
                    "layerDefs": null,
                    "layersToShow": null
                }, {
                    "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
                    "bbox": null,
                    "zIndex": 60,
                    "tokenKey": null,
                    "layerDefs": null,
                    "layersToShow": null
                }]
        },
        "name": "Imagery",
    }, {
        "key": "streets",
        "xyz": {
            "maxZoom": 19,
            "minZoom": 3,
            "endpoints": [
                {
                    "url": "https://services.arcgisonline.com/arcgis/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}",
                    "zIndex": 20
                }, {
                    "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}",
                    "zIndex": 40
                }, {
                    "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
                    "zIndex": 60,
                }]
        },
        "name": "Streets",
    }, {
        "key": "lyr_public_fires_mvt",
        "mvt": {
            "endpoints": [
                {
                    "url": "/mapping/mvt/public_fires/{z}/{x}/{y}",
                    "style": {
                        "static":
                        {
                            "fillColor": "rgba(180, 48, 200, 0.47)",
                            "strokeColor": "rgba(84, 48, 5, 0.75)",
                            "strokeWidth": 2
                        },
                        "highlight":
                        {
                            "fillColor": "rgba(180, 48, 200, 1)",
                            "strokeColor": "rgba(84, 48, 5, 1)",
                            "strokeWidth": 4
                        }

                    },
                    "zIndex": 300,
                    "headers": {
                        "accept": "application/octet-stream"
                    },
                }, {
                    "url": "/mapping/mvt/public_fires_points/{z}/{x}/{y}",
                    "style": {
                        "static":
                        {
                            "text": {
                                "dynamic": "name",
                                "font": "bold 1.5em Roboto",
                                "strokeColor": "rgba(0, 0, 0, 1)",
                                "strokeWidth": 5,
                                "fillColor": "rgba(255, 255, 255, 1)",
                                "offsetY": 0,
                                "declutterPadding": 5
                            }
                        },
                        "highlight":
                        {
                            "fillColor": "rgba(180, 48, 200, 1)",
                            "strokeColor": "rgba(84, 48, 5, 1)",
                            "strokeWidth": 4,
                            "text": {
                                "dynamic": "name",
                                "font": "bold 2em Roboto",
                                "strokeColor": "rgba(0, 0, 0, 1)",
                                "strokeWidth": 4,
                                "fillColor": "rgba(255, 255, 255, 1)",
                                "offsetY": 0,
                                "declutterPadding": 5
                            },
                            "image": {
                                "type": "circle",
                                "radius": 5,
                                "fillColor": "rgba(0, 0, 200, 0)",
                                "strokeColor": "rgba(0, 0, 5, 0.75)",
                            }
                        }

                    },
                    "zIndex": 301,
                    "headers": {
                        "accept": "application/octet-stream",
                        "name": "fool"
                    },
                }
            ],
            "declutter": true,
        },
        "name": "Wildfires",
        "legend": {
            "enabled": true,
            "items": [{
                "label": "Wildfire",
                "color": "rgba(180, 48, 200, 1)"
            }
            ]
        },
        "opacity": 1,
        "hidden": true,
    }, {
        "key": "lyr_public_fires_points_mvt",
        "mvt": {
            "endpoints": [
                {
                    "url": "/mapping/mvt/public_fires_points/{z}/{x}/{y}",
                    "style": {
                        "static":
                        {
                            "image": {
                                "type": "circle",
                                "radius": 5,
                                "fillColor": "rgba(180, 48, 200, 0.47)",
                                "strokeColor": "rgba(84, 48, 5, 0.75)",
                            }
                        }

                    },
                    "filter": null,
                    "zIndex": 301,
                    "headers": {
                        "accept": "application/octet-stream"
                    },
                    "tokenKey": null
                }
            ],
            "declutter": true
        },
        "name": "Wildfires",
        "hidden": true,
        "legend": {
            "enabled": true,
            "items": [{
                "label": "Wildfire",
                "color": "rgba(180, 48, 200, 1)"
            }
            ]
        },
        "opacity": 1
    }, {
        "key": "lyr_ut_risk",
        "wmts": {
            "maxZoom": 19,
            "minZoom": 3,
            "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428],
            "endpoints": [{
                "url": "https://utwrapcache.timmons.com/mapproxy/wmts/fireriskindex/{TileMatrixSet}/{TileMatrix}/{TileCol}/{TileRow}.png",
                "zIndex": 20,
                "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428]
            }]
        },
        "name": "Wildfire Risk",
        "opacity": 1,
        "legend": {
            "enabled": true,
            "items": [{
                "label": "Urban, Agriculture, Barren or Water"
            }, {
                "label": "Very Very Low",
                "color": "#96ad7f"
            }, {
                "label": "Very Low",
                "color": "#bad7a8"
            }, {
                "label": "Low",
                "color": "#d7cf9e"
            }, {
                "label": "Low - Moderate",
                "color": "#ffffbe"
            }, {
                "label": "Moderate",
                "color": "#ffd37f"
            }, {
                "label": "Moderate High",
                "color": "#ffaa00"
            }, {
                "label": "High",
                "color": "#ff5500"
            }, {
                "label": "Very High",
                "color": "#cf0000"
            }, {
                "label": "Extreme",
                "color": "#730000"
            }]
        }
    }, {
        "key": "lyr_ut_ownership",
        "name": "Ownership",
        "opacity": 1,
        "esriExport": {
            "maxZoom": 19,
            "minZoom": 3,
            "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428],
            "endpoints": [{
                "url": "https://gis.trustlands.utah.gov/server/rest/services/Ownership/UT_SITLA_Ownership_LandOwnership/MapServer/",
                "zIndex": 21,
                "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428],
                "legend": {
                    "size": [50, 15]
                }
            }]
        },
        "legend": {
            "enabled": true
        }
    }, { //https://gis.trustlands.utah.gov/server/rest/services/Ownership/UT_SITLA_Ownership_LandOwnership/FeatureServer/0}
        "key": "lyr_ut_ownership_f",
        "name": "Ownership (Feature)",
        "opacity": 1,
        "esriFeature": {
            "maxZoom": 19,
            "minZoom": 3,
            "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428],
            "endpoints": [{
                "url": "https://gis.trustlands.utah.gov/server/rest/services/Ownership/UT_SITLA_Ownership_LandOwnership/FeatureServer/0",
                "zIndex": 21,
                "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428]
            }]
        },
        "legend": {
            "enabled": true
        }
    }, {
        "key": "lyr_ut_landslide",
        "name": "Historical Landslide",
        "opacity": 1,
        "esriFeature": {
            "endpoints": [{
                "url": "https://services.arcgis.com/ZzrwjTRez6FJiOq4/arcgis/rest/services/Utah_Geologic_Hazards/FeatureServer/3",
                "zIndex": 24
            }]
        },
        "legend": {
            "enabled": true
        }
    }, {
        "key": "lyr_ut_land_cover",
        "wms": {
            "maxZoom": 13,
            "minZoom": 3,
            "extent": [-20037508.3428, -20037508.3428, 20037508.3428, 20037508.3428],
            "endpoints": [{
                "url": "https://www.mrlc.gov/geoserver/mrlc_display/NLCD_2019_Land_Cover_L48/wms",
                "layers": "NLCD_2019_Land_Cover_L48",
                "zIndex": 23,
                "legend": {
                    "method": "sld"
                }
            }]
        },
        "name": "Land Cover",
        "opacity": 1,
        "legend": {
            "enabled": true
        }
    }, {
        "key": "lyr_ref_places_transport",
        "xyz": {
            "maxZoom": 19,
            "minZoom": 3,
            "endpoints": [{
                "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}",
                "zIndex": 400
            }, {
                "url": "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}",
                "zIndex": 600,
            }]
        },
        "name": "Places and Transportation",
    },],
    "layerGroups": [{
        "key": "grp_basemaps",
        "name": null,
        "layers": ["lyr_esri_light_gray", "streets", "aerial", "topo"],
        "openness": "closed"
    }, {
        "key": "grp_mvt",
        "name": null,
        "layers": ["lyr_public_fires_mvt", "lyr_public_fires_points_mvt"],
        "openness": "closed"
    }, {
        "key": "grp_ref",
        "name": null,
        "layers": ["lyr_ut_risk", "lyr_ut_ownership", "lyr_ut_landslide", "lyr_ut_land_cover"]
    }],
    "layerCategories": [{
        "key": "cat_basemaps",
        "name": "Basemaps",
        "hidden": false,
        "infoIcon": {
            "iconClass": "fa fa-info-circle fa-lg"
        },
        "openness": "open",
        "activeIcon": {
            "iconClass": "fa fa-circle"
        },
        "layerGroups": ["grp_basemaps"],
        "multiphasic": false,
        "transparency": 1,
        "selectiveness": "monoselective",
        "defaultSelection": ["topo"],
        // "crossfade": {
        //     "from": "topo",
        //     "to": "arial",
        //     "duration": 0.5,
        //     "startZoom": 11,
        //     "endZoom": 12
        // }
    }, {
        "key": "cat_mvt",
        "name": "Fire History",
        "hidden": true,
        "expanded": true,
        "layerGroups": ["grp_mvt"],
        "multiphasic": false,
        "transparency": 1,
        "selectiveness": "polyselective",
        "defaultSelection": ["lyr_public_fires_points_mvt"],
        "crossfade": {
            "from": "lyr_public_fires_points_mvt",
            "to": "lyr_public_fires_mvt",
            "duration": 0.25,
            "startZoom": 8,
            "endZoom": 9
        }
    }, {
        "key": "cat_ref",
        "name": "Reference Layers",
        "layerGroups": ["grp_ref"],
        "selectiveness": "polyselective",
        "defaultSelection": [],
        "multiphasic": true,
    }, /*{
        "key": "cat_mvt_cluster",
        "name": "MVT",
        "hidden": false,
        "infoIcon": {
            "iconClass": "fa fa-info-circle fa-lg"
        },
        "openness": "open",
        "activeIcon": {
            "iconClass": "fa fa-circle"
        },
        "layerGroups": ["grp_mvt_clustered"],
        "multiphasic": false,
        "transparency": 1,
        "selectiveness": "polyselective",
        "defaultSelection": ["lyr_public_fires_points_clustered_mvt"],
        "usesRasterLegend": false,
        "mustHaveSelection": false,
    }*/],
    bbox: [0, 0, 0, 0]
};

module.exports = {
    mockMapConfig
};